// src/LoadingSpinner.js
import React from 'react';
import './LoadingSpinner.css'; // Import the CSS file for the spinner styles

const LoadingSpinner = ({ isLoading }) => {
  return (
    <div className={`loading-spinner ${isLoading ? 'show' : 'hide'}`}>
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
